module.exports = __webpack_public_path__ + "static/media/star-of-david.5aa937b7.svg";